// export const productTag = [{id:"2070" , tag:"5"},{id:"2071" , tag:"6"},{id: "2369", tag:"7"},{id: "2370", tag:"8"},{id: "2072", tag:"9"}]
export const productTag = [{id: "2369", tag:"7"},{id: "2370", tag:"8"},{id: "2072", tag:"9"}]
export const exceptionalProducts = [1,12288,65277,65328,4097]